export enum GoalType {
    Steps = 'Steps',
    Sleep = 'Sleep'
}
